import { useLeadCollectionCounts } from '@/hooks/useLeadCollectionCounts.ts';
import { LeadLifecycleStatus, LeadUrgency } from '@/models/entities/lead';

interface LeadKPICard {
  readonly label: string;
  readonly value: number | string;
  readonly bgColor: string;
  readonly textColor?: string;
}
export function LeadKPICards() {
  const counts = useLeadCollectionCounts();
  const kpis: LeadKPICard[] = [
    {
      label: LeadUrgency.Overdue,
      value: counts.overdue,
      bgColor: 'bg-red-50',
      textColor: 'text-black',
    },
    {
      label: LeadUrgency.OverdueSoon,
      value: counts.overdueSoon,
      bgColor: 'bg-yellow-50',
      textColor: 'text-black',
    },
    {
      label: LeadLifecycleStatus.Scheduled,
      value: counts.scheduled,
      bgColor: 'bg-blue-50',
      textColor: 'text-black',
    },
    {
      label: LeadLifecycleStatus.InRepair,
      value: counts.inRepair,
      bgColor: 'bg-purple-50',
      textColor: 'text-black',
    },
    {
      label: LeadLifecycleStatus.Executed,
      value: counts.executed,
      bgColor: 'bg-emerald-50',
      textColor: 'text-black',
    },
    {
      label: 'BAD/MISSING CONTACT',
      value: counts.unknownCustomer,
      bgColor: 'bg-white',
      textColor: 'text-black',
    },
  ];
  return (
    <dl className="flex gap-3 mb-6">
      {kpis.map((kpi) => (
        <div
          key={kpi.label}
          className={`${kpi.bgColor} rounded px-4 py-3 flex-1 border border-gray-200`}
        >
          <dt className="bg-black text-white text-[10px] font-bold px-2 py-0.5 inline-block mb-2">
            {kpi.label}
          </dt>
          <dd className={`text-3xl font-bold ${kpi.textColor}`}>{kpi.value}</dd>
        </div>
      ))}
    </dl>
  );
}
